export class Persona {
  IdPersona: number;
  IdDepartamento: number;
  IdProvincia: number;
  IdDistrito: number;
  IdTipoDocumento: number;
  NroDocumento: string;
  Nombre: string;
  ApellidoPaterno: string;
  ApellidoMaterno: string;
  FechaNacimiento: string;
  Edad: number;
  Email: string;
  Telefono: string;
  Celular: string;
  TipoDireccion: number;
  Direccion: string;
  EstadoCivil: number;
  Ocupacion: string;
  GradoInstruccion: number;
  IngresoMensual: number;
  TipoSituacionLab: number;
  SituacionLab: string;
  IndicadorDiscapacitado: number;
  RelacionPersona: number;
  Estado: number;
  NombreEstadoCivil: string;
  EsJefe: number;
    constructor(relacionPersona: number) {
      this.IdPersona = 0,
      this.IdTipoDocumento = 0,
      this.RelacionPersona = relacionPersona,
      this.IndicadorDiscapacitado = 0,
      this.Estado = 0;
      this.Edad = 0;
    }

}
